import $ from 'jquery';
import 'parsleyjs';
import './Language/parsley';
import 'emailDecrypt';
//import 'bootstrap';

import './General/Setup';

import './General/Select';
import './General/Menu';
//import './General/BackToTop';
import './General/Datepicker';
import './General/SmoothScroll';
import './General/TwoClick';
import './General/Search';
// import './General/LangMenu';

import './Mask/Slider';
import './Mask/Gallery';
import './Mask/Youtube';
import './Mask/Maps';
import './Mask/Accordion';
import './Mask/CaseSlider';
import './Mask/CaseStudiesOverview';
import './General/Lightbox';

var isDev = process.env.NODE_ENV !== 'production';

if (isDev) {
    console.log('%cTheme.js successfully initialized with webpack! 🌊☀', "color: green");
}

// just a simple resize trigger. Nice to have.
$(window).trigger('resize');
